import { render, staticRenderFns } from "./a-dotted-line.vue?vue&type=template&id=200bb464&scoped=true"
import script from "./a-dotted-line.vue?vue&type=script&lang=js"
export * from "./a-dotted-line.vue?vue&type=script&lang=js"
import style0 from "./a-dotted-line.vue?vue&type=style&index=0&id=200bb464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200bb464",
  null
  
)

export default component.exports